import type { FieldDefinition } from "~/models/Automation";
import {
    findExpressionField,
    parseFieldExpression,
    expressionLiteral,
} from "./fieldExpression";

export interface ExpressionField extends FieldDefinition {
    expressionState?: "missing" | "literal";
}

export function resolveExpressionField(
    fields: FieldDefinition[],
    input: string,
): ExpressionField | undefined {
    const expression = parseFieldExpression(input);
    if (!expression) return undefined;
    const literal = expressionLiteral(expression.key);
    if (!literal) {
        const field = findExpressionField(fields, input);
        if (field) return field;
        if (!/^[^\s|,(){}'"]+$/.test(expression.key)) return undefined;
    }
    return {
        key: input,
        label: expression.key,
        type: literal?.type ?? "null",
        default_value: literal?.value ?? null,
        expressionState: literal ? "literal" : "missing",
        app: "hiredata",
        object: null,
        attribute: expression.key,
        data_key: expression.key,
        options: [],
        aliases: [],
        metadata: null,
        sub_type: null,
        external_type: null,
        description: "",
        digits: 0,
        length: 0,
        precision: 0,
        is_active: true,
        is_nullable: true,
        is_updatable: false,
        is_external_id: false,
        is_searchable: false,
        is_required: false,
        is_changeable: false,
        is_id: false,
        relationship_type: null,
        is_relationship: false,
        origin_id: null,
        scope_id: null,
        conditions: [],
        references_to: [],
    };
}
